import { recordError } from '@util/Errors';
import 'firebase/compat/remote-config';
import { Experiment, ExperimentConfig, VariantOf, VariantsConfig } from './Experiment';

type QueryParamConfig<Variants extends VariantsConfig> = ExperimentConfig<Variants> & {
  /** The query param key to use. */
  queryParam: string;
  /** Map of query param values to variants */
  paramToVariantMapping: Record<string, VariantOf<Variants>>;
};

/** An experiment configured using query params. */
export class QueryParamExperiment<Variants extends VariantsConfig> extends Experiment<Variants> {
  public readonly queryParam: string;
  public readonly paramToVariantMapping: Record<string, VariantOf<Variants>>;

  public constructor(config: QueryParamConfig<Variants>) {
    const { queryParam, paramToVariantMapping, ...baseExperimentConfig } = config;
    super(baseExperimentConfig);
    this.queryParam = queryParam;
    this.paramToVariantMapping = paramToVariantMapping;
  }

  /** Get the variant from the query param if available. E.g. `?config=m5` returns `'m5'` */
  protected getVariantFromSource(): VariantOf<Variants> | undefined {
    let variant: VariantOf<Variants> | undefined = undefined;

    const queryValue = new URLSearchParams(window.location.search).get(this.queryParam);

    if (queryValue !== null) {
      if (queryValue in this.paramToVariantMapping) {
        variant = this.paramToVariantMapping[queryValue];
      } else {
        recordError(
          new Error(`Unknown query param experiment variant '${queryValue}' in ${this.name}`)
        );
      }
    }

    return variant;
  }
}
